import { fabric } from 'fabric';
import { editorConfig, getDefaultTextProps } from '~config';
import { generateObjRefId } from '~core';
import { SpellCheckTextbox } from '~core/spellcheck';
import { FEATURES, isFeatureEnabled } from '~src/features';

export const editorAddText = async (option, text = '') => {
  const defaultTextProps = getDefaultTextProps();

  let placeholder;
  let weight;
  let textAlign;
  const fontSize = Math.floor(window.canvas.width / 20);

  switch (option) {
    case 'HEADING':
      placeholder = 'Titolo';
      weight = 'normal';
      textAlign = 'center';
      break;
    case 'SUBHEADING':
      placeholder = 'Sottotitolo';
      weight = 'bold';
      textAlign = 'center';
      break;
    case 'BODY':
      placeholder = 'Testo';
      weight = 'normal';
      textAlign = 'center';
      break;
    case 'QUOTES':
      placeholder = 'Testo';
      weight = 'normal';
      textAlign = 'center';
      break;

    default:
      placeholder = defaultTextProps['text'];
      weight = defaultTextProps['fontWeight'];
      textAlign = defaultTextProps['textAlign'];
      break;
  }

  if (text) {
    placeholder = text;
  }

  // Check if spellcheck feature is enabled
  const allowSpellcheck = await isFeatureEnabled(FEATURES.SPELLCHECK);
  const TextboxClass = allowSpellcheck ? SpellCheckTextbox : fabric.Textbox;

  const textObject = new TextboxClass(placeholder, {
    left: 20,
    top: 20,
    angle: 0,
    padding: 0,
    width: Math.floor(window.canvas.width / 1.3),
    fontFamily: defaultTextProps['fontFamily'],
    fontSize,
    fontWeight: weight,
    fontStyle: defaultTextProps['fontStyle'],
    fill: defaultTextProps['color'],
    opacity: defaultTextProps['opacity'],
    underline: defaultTextProps['underline'],
    linethrough: defaultTextProps['linethrough'],
    textAlign: textAlign,
    hasRotatingPoint: true,
    editingBorderColor: editorConfig.lineColorDark,
    giotto: {
      objRefId: generateObjRefId('textbox'),
    },
    erasable: false,
  });

  window.canvas.add(textObject);
  window.canvas.renderAll();
};
